import React, { useReducer } from "react";
import AuthContext from "./videoContext";

import videoReducer from "./videoReducer";
import { appFirestore, timestamp } from "../../firebase/config";

import {
  GET_VIDEOS,
  GET_RESOURCE,
  SET_FILTER,
  ADD_COMMENT,
  GET_COMMENTS,
  CLEAR_RESOURCE,
  CLEAR_LATEST,
  ADD_REPLY,
  ADD_MORE,
} from "../types";

const VideoState = (props) => {
  const initialState = {
    videos: null,
    query: null,
    loading: false,
    colls: [],
    errors: null,
    comments: [],
    resource: null,
  };
  const [state, dispatch] = useReducer(videoReducer, initialState);

  //-----------------------------QUICK SEARCH------------------------------------
  // Gets videos from "academics" collection
  // no authentication required
  const getVideos = async (inp) => {
    /* 
    inp:{
      q: query string q, if there is a specific query. Otherwise it will return latest 10 videos posted in that type
      type: type, if present will return only one type
      collection: default academics, if other specified will return from different collection
    } 
    */

    const q = inp.q;
    const collection = inp.collection || [
      "academics",
      "extracurriculars",
      "youtube",
    ];
    const type = inp.type;

    //make reference to "videos" collection
    let vidref = appFirestore.collection(collection[0]);
    let vidref2;
    if (collection[1]) {
      vidref2 = appFirestore.collection(collection[1]);
    }
    let vidref3;
    if (collection[2]) {
      vidref3 = appFirestore.collection(collection[2]);
    }
    if (q) {
      vidref = vidref.where("tags", "array-contains-any", q);
      if (collection[1]) {
        vidref2 = vidref2.where("tags", "array-contains-any", q);
      }
      if (collection[2]) {
        vidref3 = vidref3.where("tags", "array-contains-any", q);
      }
    }
    if (type) {
      vidref = vidref.where("type", "==", type);
      if (collection[1]) {
        vidref2 = vidref2.where("type", "==", type);
      }
      if (collection[2]) {
        vidref3 = vidref3.where("type", "==", type);
      }
    }

    //since this returns a promise we use try/catch
    try {
      //send a query for searching for the search string in tags
      let allColls = {};
      let res = await vidref.orderBy("date", "desc").limit(10).get();
      let allVids = [];

      //loop through query result and put each item in an object in array
      res.forEach(async (doc) => {
        allVids.push({
          ...doc.data(),
          id: doc.id,
        });
      });
      allColls[collection[0]] = allVids;

      if (collection[1]) {
        allVids = [];
        let res2 = await vidref2.limit(10).get();
        res2.forEach(async (doc) => {
          allVids.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        allColls[collection[1]] = allVids;
      }
      if (collection[2]) {
        allVids = [];
        let res3 = await vidref3.limit(10).get();
        res3.forEach(async (doc) => {
          allVids.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        allColls[collection[2]] = allVids;
      }
      //dispatch to update state
      dispatch({ type: GET_VIDEOS, payload: allColls });
    } catch (error) {
      console.log(error.message);
      //create alert for video error
    }
  };

  //-----------------------------FILTERED VIDEOS------------------------------------

  //filter by parameter, eg branch, subject or year
  const filteredVideos = async (q, limit = 10) => {
    dispatch({ type: SET_FILTER, payload: q });
    let query = appFirestore.collection("academics");
    let query2 = appFirestore.collection("extracurriculars");
    let query3 = appFirestore.collection("youtube");

    if (q.branch) {
      query = query.where("branch", "==", q.branch);
    }
    if (q.course) {
      query = query.where("course", "==", q.course);
    }
    if (q.year) {
      query = query.where("year", "==", q.year);
    }
    if (q.subject) {
      query = query.where("subject", "==", q.subject);
    }
    if (q.query) {
      query = query.where("tags", "array-contains-any", q.query.split(" "));
    }
    if (q.tags) {
      query = query.where("tags", "array-contains-any", q.tags);
      query2 = query2.where("tags", "array-contains-any", q.tags);
      query3 = query3.where("tags", "array-contains-any", q.tags);
    }
    try {
      let allColls = {};
      let res = await query.orderBy("date", "desc").limit(limit).get();
      let allVids = [];

      if (q.tags) {
        //loop through query result and put each item in an object in array
        res.forEach(async (doc) => {
          allVids.push({
            ...doc.data(),
            id: doc.id,
            coll: "acad",
          });
        });

        let res2 = await query2.limit(limit).get();
        res2.forEach(async (doc) => {
          allVids.push({
            ...doc.data(),
            id: doc.id,
            coll: "extra",
          });
        });

        let res3 = await query3.limit(limit).get();
        res3.forEach(async (doc) => {
          allVids.push({
            ...doc.data(),
            id: doc.id,
            coll: "youtube",
          });
        });
        allColls.suggestions = allVids;
        dispatch({ type: GET_VIDEOS, payload: allColls });
      } else {
        let allColls = {};
        let res = await query.orderBy("date", "desc").limit(10).get();
        let allVids = [];

        //loop through query result and put each item in an object in array
        res.forEach(async (doc) => {
          allVids.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        allColls.academics = allVids;

        console.log(allColls);
        //dispatch to update state
        dispatch({ type: GET_VIDEOS, payload: allColls });
      }
      //dispatch to update state
    } catch (error) {
      console.log(error.message);
      //create alert for video error
    }
  };

  const getComments = async (id) => {
    let allComments = [];
    try {
      const comments = await appFirestore
        .collection("comments")
        .where("resourceid", "==", id)
        .orderBy("createdAt", "desc")
        .get();

      //loop through query result and put each item in an object in array

      comments.forEach(async (doc) => {
        let repliesList = [];
        try {
          const replies = await appFirestore
            .collection("comments")
            .doc(doc.id)
            .collection("replies")
            .get();

          if (replies.docs.length > 0) {
            replies.forEach((reply) => {
              repliesList.push({ ...reply.data(), id: reply.id });
            });
          }
        } catch (error) {
          console.log("no replies");
        }

        allComments.push({
          ...doc.data(),
          replies: repliesList,
          commentid: doc.id,
        });
      });

      dispatch({ type: GET_COMMENTS, payload: allComments });
    } catch (error) {
      console.log(error.message);
    }
  };
  const clearComments = () => {
    dispatch({ type: ADD_REPLY });
  };
  //-----------------------------GET A RESOURCE------------------------------------
  const getResource = async (data) => {
    console.log(data);
    const vidref = appFirestore.collection(data.collection || "academics");
    //since this returns a promise we use try/catch
    try {
      let res;
      let resource = {};

      res = await vidref.doc(data.id).get();
      resource = { ...res.data(), id: res.id };

      //dispatch to update state

      dispatch({ type: GET_RESOURCE, payload: resource });

      const tags = res.data().tags;

      filteredVideos({ tags });

      dispatch({ type: SET_FILTER, payload: null });
    } catch (error) {
      console.log(error.message);
      //create alert for video error
    }
  };

  const clearVideos = () => {
    dispatch({ type: CLEAR_LATEST });
  };

  const resourceUnmounts = () => {
    dispatch({ type: CLEAR_RESOURCE });
  };
  //-----------------------------ADD COMMENT------------------------------------
  const addComment = async (data) => {
    try {
      const res = await appFirestore.collection("comments").add(data);
      data.commentid = res.id;
      const newarray = [data, ...state.comments];
      dispatch({ type: ADD_COMMENT, payload: newarray });
    } catch (error) {
      console.log(error.message);
    }
  };

  //-----------------------------ADD REPLY------------------------------------
  const addReply = async (data) => {
    try {
      const uploadData = data.commentid;
      delete data.commentid;
      console.log(data);
      const res = await appFirestore
        .collection("comments")
        .doc(uploadData)
        .collection("replies")
        .add(data);
      data.id = res.id;
      const newCommentArray = state.comments.map((comment) => {
        if (comment.commentid === uploadData) {
          comment.replies = [data, ...comment.replies];
        }
        return comment;
      });

      dispatch({
        type: ADD_COMMENT,
        payload: newCommentArray,
      });
      return;
    } catch (error) {
      console.log(error.message);
    }
  };

  //--------------------------------------------GET MORE VIDEOS------------------------------------------

  const addLecture = async (info) => {
    let id = info.id;
    delete info.id;
    await appFirestore
      .collection("academics")
      .doc(id)
      .set({ ...info, date: timestamp() });
  };
  return (
    <AuthContext.Provider
      value={{
        videos: state.videos,
        query: state.query,
        errors: state.errors,
        comments: state.comments,
        resource: state.resource,
        clearVideos,
        getVideos,
        addComment,
        addReply,
        getComments,
        filteredVideos,
        clearComments,
        addLecture,
        resourceUnmounts,
        getResource,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default VideoState;
